import { PrimaryFocus } from '@/domain/primaryFocus/constant'
import { Center } from '@/types/models/Center.model'
import { isPPV } from '@/domain/center'
const PRIMARY_FOCUS_VALUES_TO_SHOW_LOCAL_OVERRIDE = [
  PrimaryFocus.EATING_DISORDERS
]

export const shouldUsePPVForLocalCentersInFeed = ({
  primaryFocus,
  center
}: {
  primaryFocus: PrimaryFocus
  center: Center
}) => {
  if (PRIMARY_FOCUS_VALUES_TO_SHOW_LOCAL_OVERRIDE.includes(primaryFocus)) {
    return true
  }

  return isPPV(center)
}
